var destination_root = 'https://api.pycrunch.com'
let local_api = 'http://0.0.0.0:8000'

let webapp_link = 'https://app.pytrace.com'
// let webapp_link = 'http://0.0.0.0:8888'
var config = {
  api_root: destination_root,
  webapp_link: webapp_link,
}

export default config